module.exports = __webpack_public_path__ + "static/media/loginBg.6d75c808.png";